import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/state';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import '../../../../../../../types/product.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/lib-cookies';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { CLPrescriptionSelect } from './CLPrescriptionSelect.js';

const CLPrescriptionSelectContainer = ({ attributeConfig: { name , attributeOptions  } , selectClassName , eyeSideId , onChange , isDisabled  })=>{
    var ref;
    const { state , selectors  } = useCLEcommContext();
    // Get the selected prescription value (if defined) for this attribute
    const selectedValue = (ref = state.configurations[eyeSideId].prescription[name]) === null || ref === void 0 ? void 0 : ref.toString();
    // Get the UI validation state for the entire configurator
    const { invalidSubmissionsCount  } = state.configurator;
    const hasError = React.useMemo(()=>{
        const hasSubmissionError = Boolean(invalidSubmissionsCount && !isDisabled && !selectedValue);
        const hasQueryError = selectors.hasNonRecoverableErrorOnEyeside(state, eyeSideId);
        return hasSubmissionError || hasQueryError;
    }, [
        eyeSideId,
        invalidSubmissionsCount,
        isDisabled,
        selectedValue,
        selectors,
        state
    ]);
    return /*#__PURE__*/ React.createElement(CLPrescriptionSelect, {
        name: name,
        selectClassName: selectClassName,
        eyeSideId: eyeSideId,
        options: attributeOptions,
        isDisabled: isDisabled,
        selectedValue: selectedValue,
        onChange: onChange,
        hasError: hasError
    });
};

export { CLPrescriptionSelectContainer };
//# sourceMappingURL=CLPrescriptionSelectContainer.js.map
